import React from 'react';
import { Box, Chip, Button } from '@mui/material';
import { INK, FONT } from './vizTokens';

/**
 * Names the filters currently narrowing the page.
 *
 * Without this, clicking a bar or a heat cell silently narrows everything below
 * it and nothing on screen says why — which is the difference between
 * cross-filtering feeling powerful and feeling broken. Each chip clears only
 * its own filter, so a wrong click costs one click to undo rather than a reset.
 */
const FilterChips = ({ filters, onClearAll }) => {
  const active = (filters || []).filter((f) => f.value);
  if (active.length === 0) return null;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center', mb: 2.5 }}>
      {active.map((f) => (
        <Chip
          key={f.key}
          label={`${f.label}: ${f.display || f.value}`}
          onDelete={f.onClear}
          size="small"
          sx={{
            ...FONT,
            fontSize: '12.5px',
            height: '28px',
            borderRadius: '14px',
            backgroundColor: INK.plane,
            color: INK.primary,
            border: `1px solid ${INK.border}`,
            '& .MuiChip-deleteIcon': {
              color: INK.muted,
              '&:hover': { color: INK.primary },
            },
          }}
        />
      ))}
      {active.length > 1 && (
        <Button
          size="small"
          onClick={onClearAll}
          sx={{ ...FONT, textTransform: 'none', fontSize: '12.5px', color: INK.secondary }}
        >
          Clear all
        </Button>
      )}
    </Box>
  );
};

export default FilterChips;
